import { Component } from '@angular/core';
import { Program, Session } from 'globals/store/programs.data';
import { Wrapper } from '../../components/wrapper.component';
import { programsArray } from '../../store/reselectors/programs.reselector';
import { JoiEvent } from 'globals/store/events.data';
import { eventReadOnlyReselector } from '../../store/reselectors/events.reselector';
import { AttendeesViewInfo } from 'globals/store/share.data';
import { Attendee } from 'globals/store/attendees.data';
import { Dictionary } from '@ngrx/entity';
import { EntitySelectorData, EntitySelectorDialogComponent } from '../../components/entities/entity-selector.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { listsMatch } from '../../helpers/helpers';
import { BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { AttendeesViewComponent } from './attendees-view.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'edit-attendees-view',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<div class="cue-sheets" *ngIf="!!event">
  <div class="controls">
    <action-button *ngIf="!readOnly" [text]="readMode ? 'EDIT MODE' : 'VIEW MODE'" (click)="readMode = !readMode"></action-button>
  </div>

  <binary-share-toggle
    class="notes-top"
    [type]="'brief'"
    [shareType]="shareTypes.attendeesView"
    [shareableFormat]="'oneLine'"
    [shareCode]="info?.publishCode || ''"
    [hint]="'Note: The shareable webpage is dynamic and will always load the current run of show.'"
    [title]="'Attendees Webpage'"
    [shareTitle]="'Your shareable webpage:'"
    [status]="info?.status || 'Off'"
    (toggle)="toggleShare($event)"
  ></binary-share-toggle>

  <attendees-view *ngIf="!!event" 
    [eventTitle]="event?.title || 'Unnamed Event'" 
    [programs]="programs" 
    [brandingData]="brandingData"
    [attendees]="attendees"
    [readOnly]="readOnly || readMode"
    (save)="saveSession($event)"
    (openTagger)="openTagger($event)"
  ></attendees-view>
</div>
<loader-pane-fragment [trace]="traceNames.viewAttendeeSessions"></loader-pane-fragment>
`,
    styleUrls: ['../cues/cue-sheets.scss', '../../page.scss'],
    styles: [`
  binary-share-toggle { margin-top: 20px; margin-bottom: 20px; }  
  action-button { margin-left: auto; }
`],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, CommonModule, BinaryShareToggle, ActionButtonComponent, TopMenuComponent, MobileMenuComponent, AttendeesViewComponent]
})
export class EditAttendeesView extends Wrapper<EditAttendeesView> {
  programs: Program[]
  event: JoiEvent
  readOnly: boolean
  info: AttendeesViewInfo
  attendees: Dictionary<Attendee>
  brandingData: BrandingData
  readMode = false
  traceNames = traceNames

  constructor() {
    super()
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      brandFormType: 'attendees'
    }
    
    this.selectProp(programsArray, null, 'programs')
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.selectProp(eventReadOnlyReselector, null, 'readOnly')
    this.subProp(this.store.select('attendees', 'entities'), 'attendees')
    this.subCallback(this.store.select('events', 'event'), event => {
      if (!event) return
      if (!this.event) {
        this.subProp(this.store.select('shareables', 'attendeeView', event.eventId), 'info')
      }
      this.event = event
    })
  }

  toggleShare(share: boolean) {
    
    if (!this.info) this.attendeeService.addAttendeeShare(this.eventService.eventId)
    else this.attendeeService.changeShareStatus({ ...this.info, status: share ? 'On' : 'Off' })
  }

  saveSession({ session, programId }: { session: Session, programId: string }) {
    console.log({ session, programId })
    this.programService.updateSession(programId, session)
  }

  async openTagger({ event, session, programId }: { event: any, session: Session, programId: string }) {

    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const selectedEntities = {}
    
    const preTaggedIds = session.attendeeTags || []
    const entities = Object.values(this.attendees)
    console.log({ event, session, programId, entities })
    
    entities.forEach(e => selectedEntities[e.id] = preTaggedIds.includes(e.id))
    const data: EntitySelectorData = { 
      tagOnly: true,
      selectedEntities,
      entities, 
      searchPlaceholder: `Search attendees`, 
      entityName: 'Attendee',
      rect,
      entityHolderName: 'ATTENDEES'
    }
    console.log(data)

    await openDialogGetResult<Promise<string[]>>(this.dialog, EntitySelectorDialogComponent, { width: '300px', data, disableClose: false, backdropClass: 'clear' })
    const selected = Object.entries(selectedEntities).filter(([_, ticked]) => ticked).map(([id, _]) => id)
    if (listsMatch(selected, preTaggedIds)) return

    session.attendeeTags = selected
    this.programService.updateSession(programId, session)
  }

}

